import { Serializer, UISerializableFundingPaymentRecord } from '@drift/common';
import { getFundingHistoryFilter } from 'src/utils/historyTables';
import { useComposedHistory } from './useComposedHistory';
import type { HistoryTableUIProps } from './historyDataTypes';

export const useFundingPaymentsHistory =
	(): HistoryTableUIProps<UISerializableFundingPaymentRecord> => {
		const { historyData, executePageChange } = useComposedHistory(
			'funding-payments',
			Serializer.Deserialize.UIFundingPayment
		);

		return {
			executePageChange,
			filterFn: getFundingHistoryFilter,
			historyData,
		};
	};
